import { SnackbarProvider } from 'notistack';
import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import UtilitiesSnackbar from '../components/UtilitiesSnackbar';
import { AuthFactory } from './AuthFactory';
import { IdpProvider } from './IdpProvider';

export const AuthProviders: React.FC<PropsWithChildren> = () => {
  return (
    <SnackbarProvider
      Components={{
        utilities: UtilitiesSnackbar,
      }}
    >
      <IdpProvider>
        <AuthFactory>
          <Outlet />
        </AuthFactory>
      </IdpProvider>
    </SnackbarProvider>
  );
};
